<template>
  <Card class="main card-height-480">
    <v-toolbar height="50px" class="sub-header dialog-header" color="primary darken-1">
      <v-toolbar-title class="body-2">{{ $t('STATIC PLANT INFO') }}</v-toolbar-title>
      <v-spacer />
      <v-icon @click="$emit('close')">close</v-icon>
    </v-toolbar>
    <SimpleList :data="staticInfo" class="pl-4 pr-4" />
  </Card>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SimpleList from '@/components/common/SimpleList.vue'

export default {
  components: {
    SimpleList
  },
  data() {
    return {
      staticInfo: []
    }
  },
  computed: {
    ...mapGetters(['getActivePlantInfo', 'getSelectedPlantId', 'getRules']),
    getPlantOverviewStaticInfo() {
      const staticInfo = {};
      const staticInfoParam = this.getRules(["rule", "comp_config", "plant_overview", "options", "staticInfo"]);
      Object.entries(staticInfoParam).forEach(([key, value]) => {
        staticInfo[key] = staticInfoParam[value];
      });

      return staticInfo;
    }
  },
  mounted() {
    this.getStaticInfo()
  },
  methods: {
    getStaticInfo() {
      const oldPlantStaticInfo = this.getPlantOverviewStaticInfo
      const newPlantStaticInfo = this.getActivePlantInfo("plant_static_info");

      this.staticInfo = []
      if (newPlantStaticInfo !== null) {
        this.staticInfo = newPlantStaticInfo
      } else {
        const staticInfo = []
        Object.entries(oldPlantStaticInfo).forEach(([key, value]) => {
          const temp = {}
          temp['name'] = key
          temp['value'] = value
          staticInfo.push(temp)
        })
        this.staticInfo = staticInfo
      }
    }
  },
  watch: {
    async getSelectedPlantId() {
      await this.getStaticInfo()
    }
  }
}
</script>

<style scoped>
	.card-height-480 {
		min-height: 550px;
		max-height: 600px;
		overflow-y: auto;
	}


  .dialog-header {
    position: sticky;
    top: 0;
  }
</style>
